export enum BillDisposition {
  Correction = 'Correction',
  HasBeenCorrected = 'Has Been Corrected',
  InfoOnly = 'Info Only',
}
